import { Component, Input, OnDestroy } from "@angular/core";
import { GridOptions, ModuleRegistry } from "@ag-grid-community/core";
import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";
import { Subject } from "rxjs";

ModuleRegistry.registerModules([MasterDetailModule]);
@Component({
  selector: "app-smart-data-grid",
  templateUrl: "./smart-data-grid.component.html",
  styleUrls: ["./smart-data-grid.component.scss"],
})
export class SmartDataGridComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() gridOptions: GridOptions;
  @Input() height: string;
  constructor() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
